









































































import Component from 'vue-class-component';
import { Prop, PropSync, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { formatISO, parseISO } from 'date-fns';

const isValidTime = (value: string) => /^([01]\d|2[0-3]):[0-5]\d$/.test(value);

@Component({})
export default class TimeRegistrationForm extends Vue {
    @Prop({ type: Boolean, default: false })
    loading!: boolean;

    @PropSync('startedAtDate', { type: String, default: () => formatISO(new Date()) })
    startedAtDateSync!: string;

    @PropSync('timeSpentInMinutes', { type: Number, default: 10 })
    timeSpentInMinutesSync!: number;

    startedAtDateInternal = '';
    startedAtTimeInternal = '00:00';

    @Watch('startedAtDateSync', { immediate: true })
    updateStartedAt(): void {
        this.startedAtDateInternal = this.startedAtDateSync
            .split('T')[0];
        this.startedAtTimeInternal = `${parseISO(this.startedAtDateSync).getHours()
            .toString()
            .padStart(2, '0')}:${parseISO(this.startedAtDateSync)
            .getMinutes()
            .toString()
            .padStart(2, '0')}`;
    }

    @Watch('startedAtTimeInternal', { immediate: true })
    updateStartedAtTimeInternal(value: string): void {
        if (!isValidTime(value)) {
            return;
        }

        const [hours, minutes] = value.split(':').map(Number);
        const updatedDate = parseISO(this.startedAtDateSync);
        updatedDate.setHours(hours);
        updatedDate.setMinutes(minutes);

        this.startedAtDateSync = formatISO(updatedDate);
    }

    @Watch('startedAtDateInternal', { immediate: true })
    emitNewStartedAt(value: string): void {
        const [hours, minutes] = this.startedAtTimeInternal.split(':').map(Number);
        const updatedDate = parseISO(value);
        updatedDate.setHours(hours);
        updatedDate.setMinutes(minutes);

        this.startedAtDateSync = formatISO(updatedDate);
    }

    addStartedAtMinutes(minutes: number): void {
        const updatedDate = new Date(this.startedAtDateSync);
        updatedDate.setMinutes(updatedDate.getMinutes() + minutes);
        this.startedAtDateSync = formatISO(updatedDate);
    }

    get todayDate(): string {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }
}
